export enum AuthErrorCode {
  NetworkError = 1,
}
export class AuthError {
  constructor(public error: string, public code: AuthErrorCode) {}
}
